'use client'

import { useEffect, useState } from 'react'
import Script from 'next/script'

import { usePathname } from '@/i18n/navigation'

import { StoryblockType } from '../types'

interface StoryblockProps {
  blockData: StoryblockType
}

const Storyblock = ({ blockData }: StoryblockProps) => {
  const pathName = usePathname()

  const [storyblockLoaded, setStoryblockLoaded] = useState(false)

  useEffect(() => {
    if (storyblockLoaded) {
      setTimeout(() => {
        if (pathName !== '/') {
          const fwEl = document.getElementById('fw-player')
          if (fwEl) {
            fwEl.style.display = 'none'
          }
        }

        const fwEl = document.getElementById('fw-player')
        if (fwEl) {
          fwEl.style.display = 'flex'
        }
      }, 500)
    }

    return () => {
      const fwEl = document.getElementById('fw-player')
      if (fwEl) {
        fwEl.style.display = 'none'
      }
    }
  }, [storyblockLoaded, pathName])

  return blockData ? (
    <>
      {blockData.firework_type.includes('storyblock') && (
        <Script
          src="https://asset.fwcdn3.com/js/storyblock.js"
          strategy="lazyOnload"
          onLoad={() => setStoryblockLoaded(true)}></Script>
      )}
      {blockData.firework_type.includes('embed-feed') && (
        <Script src="https://asset.fwcdn3.com/js/embed-feed.js" strategy="lazyOnload"></Script>
      )}
      {blockData.magento_integration.includes('1') && (
        <Script
          src="https://asset.fwcdn3.com/js/integrations/magento.js"
          strategy="lazyOnload"></Script>
      )}
      <div dangerouslySetInnerHTML={{ __html: blockData.data }}></div>
    </>
  ) : null
}

export default Storyblock
